import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';

import { URL, COMPONENT, FINANCE_RESOURCES, GET_ACTION } from './helper';
import FinanceHome from './FinanceHome';

const Finance: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.dashboard}
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.finance]}
					component={FinanceHome}
				/>
				{_map(_values(FINANCE_RESOURCES), (subEntity: string) => {
					return (
						<AuthorizedRoute
							key={subEntity}
							configPageName={PAGE_NAMES.dashboard}
							entity={DASHBOARD_RESOURCES.finance}
							actions={[GET_ACTION[subEntity]]}
							path={URL[subEntity]}
							component={COMPONENT[subEntity]}
						/>
					);
				})}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.finance]} />
			</Switch>
		</>
	);
};

export default Finance;
